import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './modules/auth/_services/auth.guard';
import {PrivacyForAllComponent} from "./privacy-for-all/privacy-for-all.component";
import {ReferenceLinkForAllComponent} from "./reference-link-for-all/reference-link-for-all.component";
import {VerificationCodeComponent} from "./modules/auth/verification-code/verification-code.component";

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./modules/errors/errors.module').then((m) => m.ErrorsModule),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/layout.module').then((m) => m.LayoutModule),
  },
  {
    path: 'privacy',
    component:PrivacyForAllComponent
  },
  {
    path: 'verification',
    component: VerificationCodeComponent,
  },
  {
    path: 'reference-links/:id',
    component:ReferenceLinkForAllComponent
  },
  { path: '**', redirectTo: 'error/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
